import {styled, Theme} from "@mui/material/styles";
import {Grid} from "@mui/material";

export const SearchResultsContainer = styled(Grid)(({theme}: { theme: Theme }) => ({
  paddingTop: '.06em',
  overflow: 'visible',
  height: 'auto',
  [theme.breakpoints.down('lg')]: {
    width: '100%',
  }
}));

export const MainGridContainer = styled(Grid, {
  shouldForwardProp: (propName: PropertyKey) => propName !== 'showRequestLocationForm'
})(() => ({
  minHeight: '75vh',
  position: "relative",
  overflow: 'visible'
}));

type LeftContainerAdditionalProps = {
  isMapActive: boolean
}

export const LeftContainer = styled(Grid, {
  shouldForwardProp: (propName: PropertyKey) => propName !== 'isMapActive'
})(({theme, isMapActive}: { theme: Theme } & LeftContainerAdditionalProps) => ({
  width: "48em",
  height: 'fit-content',
  maxHeight: 'none',
  border: 'none',
  overflow: 'visible',
  ...(isMapActive ? {
    [theme.breakpoints.down('lg')]: {
      display: 'none', // Hide the element
      flex: 'none', // Don't participate in flexbox layout
      width: 0 // No width when hidden
    }
  } : {
    [theme.breakpoints.down('lg')]: {
      width: "100%",
    },
  })
}));
